/**
 * @file  src\mobile\components\PropertyListingMob.js
 * @brief  This file is responsible for property listing view
 * @date   April, 2024
 * @author ZCO Engineer
 * @copyright (c) 2024, ZCO
 */
import React, { useEffect, useState } from "react";
import BedSmallIcn from "../../images/bed-small-icn.svg";
import BathSmallIcn from "../../images/bath-small-icn.svg";
import SqftSmallIcn from "../../images/sqft-small-icn.svg";
import PreApprovedLogo from "../../../images/v2/PreApprovedIcon.svg";
import LakeViewImage from "../../../images/lake-view-icon.svg";
import DisplacedFired from "../../../images/v2/displaced-fire.svg";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import HearttIcon from "../../../images/mob-like-outline-btn.svg";
import HearttIconFilled from "../../../images/mob-like-filled-btn.svg";
import ViewAddClientsModal from "../Favorites/ViewAddClientsModal";
import PremiumFeatureStar from "../../../images/v2/premium-features-stars.svg";
import "../../../mobile/styles/v2/mobile-style.scss";
import {
  loggedInUser,
  getLocalStorage,
  formateDate,
  durationForFlexibleDate,
  monthNameForFlexibleDate,
  getUserId,
  removeDecimalZeros,
  getUserType,
  locationDisplay,
} from "../../../helpers/common";
import { useSearchParams, useNavigate } from "react-router-dom";
import {
  ADTYPE_LTR,
  ADTYPE_STR,
  BUDGET_NOMIN_NOMAX,
  IN_CITY_LIMITS,
  RURAL,
  USER_INFO_KEY,
  USER_TYPE_AGENT,
} from "../../../constants/common";
import Tooltip from "react-bootstrap/Tooltip";
import { setLotSizeValue } from "../../../helpers/createWantAd";
import {
  getPropertyIcon,
  getCombinedText,
} from "../../../helpers/getPropertyIcons";
import { wantAdBudgetValue } from "../../../helpers/createWantAd";
import { useSelector } from "react-redux";
import DefaultProfile from "../../../images/v2/Profiles.svg";
import { thousandSeparatedValueWithoutCents } from "../../../helpers/v2/common";
import { pageURLs } from "@/constants";
import { useAppConfig } from "@/appConfig";
import { usePolygons } from "@/hooks";
import StaticMapboxComponent from "../../../components/Common/StaticMapboxComponent";

const PropertyWantAdListingMob = ({
  handleFavoriteOrUnfavoriteWantAd,
  onChangeText,
  onAddClient,
  handleWantAdItemClick,
  key,
  ...props
}) => {
  const [verifyUser, setVerifyUser] = useSearchParams();
  const isUserVerified = verifyUser.get("verify");
  const [isFavourite, setIsFavourite] = useState(0);
  const [wantAdId, setWantAdId] = useState(0);
  const [modalShow, setModalShow] = useState(false); //
  const user = loggedInUser();
  const navigate = useNavigate();
  const sessionData = getLocalStorage(USER_INFO_KEY);
  const {
    Title_Text,
    Bedrooms,
    Bathrooms,
    Budget_mn,
    Budget_mx,
    Sqft_mn,
    Sqft_mx,
    N2H,
    score,
    isLotLand,
    LotType_Rural_City,
    LotSz_mn,
    LotSz_mx,
    AdType,
    Want_ad_Id,
    IsFavourite,
    subPropertyTypeId,
    Date_From,
    Date_To,
    DateType,
    Duration,
    Month,
    Longitude,
    Latitude,
    mapRadius,
    zipCode,
    CreatedBy,
    financeTypeText,
    isApprovedForLoan,
    userFirstName,
    userLastName,
    userAvatar,
    userCompany,
    userUserTypeId,
    fireDisplaced,
    Is_Agent_Created,
    slug,
    syndicationPrivacy: syndicationPrivacyProp,
    syndicationFeed: syndicationFeedProp,
    aiExplanation,
    aiHighlights,
    aiBonus,
    aiProcessed,
  } = props && props.list;

  const [showAiInsights, setShowAiInsights] = useState(false);

  const { polygonCoordinates, isLoading: isPolygonLoading } = usePolygons(zipCode);

  const loggedInUserId = getUserId();
  const [isPremiumUser, setIsPremiumUser] = useState(null);
  const userDetailsFromStore = useSelector(
    (state) => state.userProfile.userDetails,
  );
  const userType = getUserType();

  const { flags, tenant } = useAppConfig();
  const isDemoTenant = tenant?.demoMode === true;
  const blsId = isDemoTenant ? 100000 + (Want_ad_Id % 99999) : null;

  let budget = wantAdBudgetValue(Budget_mn, Budget_mx);
  if (budget != BUDGET_NOMIN_NOMAX) {
    if (AdType === ADTYPE_LTR) {
      budget = budget + " /Month";
    } else if (AdType === ADTYPE_STR) {
      budget = budget + " /Night";
    }
  }
  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const loadNiceToHaveList = () => {
    let count = 0;
    let nice = N2H.slice(0, 3);
    return (
      nice &&
      nice.map((nh, index) => {
        count++;
        const id = _.get(nh, "N2H_Id");
        const itemText = _.get(nh, "Text", "");
        const icon = _.get(nh, "Icon", "");
        return (
          <>
            <div
              className="property-tag-viewad"
              key={index + "_" + _.get(nh, "Want_ad_Id", "")}
            >
              <div className="tag-icon-mobile-viewad">
                <img
                  src={
                    icon ? require("../../../images/" + icon) : LakeViewImage
                  }
                />
              </div>
              <span>{itemText}</span>
            </div>
          </>
        );
      })
    );
  };

  /**
   * to handle clients favorites action
   * @param {*} agentIds
   */
  const handleClientFavoriteWantAd = (agentIds) => {
    handleFavoriteOrUnfavoriteWantAd(isFavourite, wantAdId, agentIds);
  };

  /**
   * handle agents favorite action, to open client list popup
   */
  const handleAgentsFavoriteAction = (IsFavourite, Want_ad_Id) => {
    setIsFavourite(IsFavourite);
    setWantAdId(Want_ad_Id);
    setModalShow(true);
  };

  useEffect(() => {
    if (userDetailsFromStore !== null && userDetailsFromStore?.length > 0) {
      if (userDetailsFromStore[0]?.period !== 1 && userType === 2) {
        setIsPremiumUser(true);
      } else {
        setIsPremiumUser(false);
      }
    }
  }, [userDetailsFromStore]);

  const loadMustHaves = () => {
    if (isLotLand) {
      if (LotType_Rural_City) {
        return (
          <>
            <li>
              <span className="list-txt-btm">
                {LotType_Rural_City === 1 ? RURAL : IN_CITY_LIMITS}{" "}
              </span>
              <span className="list-txt-btm">lot type</span>
              <li className="sep-v-line">|</li>
              <span className="list-txt-btm">
                {setLotSizeValue(
                  removeDecimalZeros(LotSz_mn),
                  removeDecimalZeros(LotSz_mx),
                )}
              </span>{" "}
              {setLotSizeValue(
                removeDecimalZeros(LotSz_mn),
                removeDecimalZeros(LotSz_mx),
              ) === "Any" ? (
                <span className="list-txt-btm">lot size</span>
              ) : (
                <></>
              )}
            </li>
          </>
        );
      } else {
        return (
          <>
            <li>
              <span className="list-txt-btm">
                {setLotSizeValue(
                  removeDecimalZeros(LotSz_mn),
                  removeDecimalZeros(LotSz_mx),
                )}
              </span>{" "}
              {setLotSizeValue(
                removeDecimalZeros(LotSz_mn),
                removeDecimalZeros(LotSz_mx),
              ) === "Any" ? (
                <span className="list-txt-btm">lot size</span>
              ) : (
                <></>
              )}
            </li>
          </>
        );
      }
    } else {
      let bedRm;
      let bathRm;
      let sqFt;
      let timeLine;
      if (Bedrooms) {
        if (Bedrooms === 99) {
          bedRm = "Any ";
        } else {
          bedRm = Bedrooms + "+";
        }
      }
      if (Bathrooms) {
        if (Bathrooms === 99) {
          bathRm = "Any ";
        } else {
          bathRm = Bathrooms + "+";
        }
      }
      const sqFtMn = Sqft_mn && Sqft_mn * 1; //Multiplying by 1 for  avoiding zeros after the decimal part (eg: if value is 100.00 then it should show 100)
      let sqFtMx = Sqft_mx && Sqft_mx * 1;
      if (sqFtMx == 5000) {
        sqFtMx = "5000+";
      }
      if (sqFtMn && sqFtMx) {
        sqFt = `${sqFtMn} - ${sqFtMx}`;
      } else if (!sqFtMn && sqFtMx) {
        sqFt = `No min - ${sqFtMx}`;
      } else if (sqFtMn && !sqFtMx) {
        sqFt = `${sqFtMn} - No max`;
      } else {
        //sqFt = `No min - No max`;
        sqFt = `Any`;
      }
      if (AdType === ADTYPE_STR) {
        if (DateType === 1 || DateType == null) {
          timeLine =
            formateDate(Date_From, "mm/dd/yyyy") +
            " - " +
            formateDate(Date_To, "mm/dd/yyyy");
        } else if (DateType === 2) {
          timeLine =
            durationForFlexibleDate(Duration) +
            " - " +
            monthNameForFlexibleDate(Month);
        }
      }

      return (
        <>
          <li>
            <span className="list-txt-btm">{bedRm}</span>
            <span className="list-icns-btm">
              <img src={BedSmallIcn} />
            </span>
          </li>
          <li className="sep-v-line">|</li>
          <li>
            <span className="list-txt-btm">{bathRm}</span>
            <span className="list-icns-btm">
              <img src={BathSmallIcn} />
            </span>
          </li>
          <li className="sep-v-line">|</li>
          <li>
            <span className="list-txt-btm">{sqFt}</span>
            <span className="list-icns-btm">
              <img src={SqftSmallIcn} />
            </span>
          </li>
        </>
      );
    }
  };

  const renderTooltip = (props) => (
    <Tooltip
      id="button-tooltip"
      placement="bottom-start"
      className="custom-tooltip"
      {...props}
    >
      {subPropertyTypeId &&
        subPropertyTypeId?.length > 0 &&
        getCombinedText(subPropertyTypeId)}
    </Tooltip>
  );

  const syndicationPrivacy = syndicationPrivacyProp ?? "show";
  const syndicationFeed = syndicationFeedProp ?? "public";

  return (
    <>
      <a
        role="button"
        className="property-listing-link-mob"
        href={void 0}
        onClick={(e) => {
          handleWantAdItemClick(slug);
        }}
      >
        <div className="property-listing-mob property-listing-main" key={key}>
          <div
            onClick={(e) => {
              e.stopPropagation();
            }}
            onKeyDown={(e) => {
              e.stopPropagation();
            }}
            role="button"
          >
            {(user || isUserVerified) && CreatedBy != loggedInUserId ? (
              IsFavourite ? (
                <a
                  role="button"
                  className="mobile-like-btn"
                  href={void 0}
                  onClick={() => {
                    handleFavoriteOrUnfavoriteWantAd(true, Want_ad_Id);
                  }}
                >
                  <img src={HearttIconFilled} />
                </a>
              ) : (
                <a
                  role="button"
                  href={void 0}
                  onClick={() => {
                    sessionData?.userInfo?.userType == 2 && isPremiumUser
                      ? handleAgentsFavoriteAction(false, Want_ad_Id)
                      : handleFavoriteOrUnfavoriteWantAd(false, Want_ad_Id);
                  }}
                  className="mobile-like-btn property-type-badge"
                >
                  <img src={HearttIcon} />
                </a>
              )
            ) : (
              ""
            )}
          </div>
          {aiExplanation ? (
            <OverlayTrigger
              placement="bottom"
              delay={{ show: 200, hide: 300 }}
              overlay={
                <Tooltip id="ai-match-tooltip-mob" className="ai-match-tooltip">
                  <strong>Why this match</strong>
                  <br />
                  {aiExplanation}
                </Tooltip>
              }
            >
              <div
                className="match-tag-mobile match-tag-ai"
                style={{ marginLeft: "0 !important" }}
              >
                {score}% Match
              </div>
            </OverlayTrigger>
          ) : (
            <div
              className="match-tag-mobile"
              style={{ marginLeft: "0 !important" }}
            >
              {score}% Match
            </div>
          )}

          <div
            className={`property-type-wrap-mob property-type-badge property-type-badge-matches ${fireDisplaced ? "firedisplaced" : ""}`}
          >
            <OverlayTrigger
              placement="bottom-start"
              delay={{ show: 250, hide: 400 }}
              overlay={renderTooltip}
            >
              <div className="property-tile-mob w-auto">
                {
                  <>
                    {subPropertyTypeId &&
                      subPropertyTypeId?.length > 0 &&
                      subPropertyTypeId.slice(0, 3).map((subtype) => {
                        return (
                          <img
                            src={getPropertyIcon(subtype)}
                            alt={getPropertyIcon(subtype)}
                            className="property-icon-img"
                          />
                        );
                      })}
                    {subPropertyTypeId?.length > 3 ? (
                      <span> +{subPropertyTypeId?.length - 3}</span>
                    ) : (
                      <></>
                    )}
                  </>
                }
              </div>
            </OverlayTrigger>
          </div>
          <div className="property-info-wrap-mob mb-3">
            {/* FIRE DISPLACED */}
            {fireDisplaced ? (
              <>
                <div className="dis-fires-mobile">
                  <img
                    src={DisplacedFired}
                    alt="displaced-fired"
                    className="displaced-fired"
                    width={"9px"}
                    height={"11px"}
                  />
                  DISPLACED BY FIRES
                </div>
              </>
            ) : null}
            <h6 className="long-txt-fix-head">{Title_Text} </h6>
            <p className="list-txt-btm-para m-0">
              {locationDisplay(props.list)}
            </p>
          </div>
          <div className="property-img-wrap-mob h-120 overflow-x-hidden">
            <StaticMapboxComponent
              padding={20}
              width={366}
              height={120}
              center={[Longitude, Latitude]}
              radiusMiles={mapRadius}
              polygonCoordinates={polygonCoordinates}
              showPolygon={
                Array.isArray(polygonCoordinates) &&
                polygonCoordinates.length > 0 &&
                Array.isArray(zipCode) &&
                zipCode.length > 0
              }
              isPolygonLoading={isPolygonLoading && Array.isArray(zipCode) && zipCode.length > 0}
            />
          </div>
          <div className="property-info-outer-mob">
            <div className="property-top-mob">
              <div className="property-info-wrap-mob">
                <div className="price-container align-items-baseline">
                  <div className="prize-range-badge-mob align-items-baseline property-price-badge">
                    {budget}
                  </div>
                  {financeTypeText && (
                    <div className="property-type-banner">
                      {financeTypeText == "Conventional Mortgage" &&
                        isApprovedForLoan ? (
                        <img
                          src={PreApprovedLogo}
                          alt={PreApprovedLogo}
                          className="type-icon"
                        />
                      ) : null}
                      {financeTypeText === "Conventional Mortgage" &&
                        isApprovedForLoan
                        ? "Pre-Approved Buyer"
                        : financeTypeText !== "Other"
                          ? `${financeTypeText} Buyer`
                          : ""}
                    </div>
                  )}
                </div>
                {/* <h6 className="long-txt-fix">{Title_Text} </h6> */}
                <ul className="want-ad-btm-list mb-0">
                  {/* <li className="sep-v-line">|</li> */}
                  {loadMustHaves()}
                </ul>

                <div className="property-tag-viewad-wrap">
                  {loadNiceToHaveList()}

                  {N2H.length > 3 && (
                    <div className="property-tag-count propery-tag-count-btmmargin">
                      +{N2H.length - 3}
                    </div>
                  )}
                </div>

                {/* AI Match Insights - collapsible section */}
                {aiExplanation && (
                  <div className="ai-match-insights">
                    <button
                      className="ai-insights-toggle"
                      onClick={(e) => {
                        e.stopPropagation();
                        setShowAiInsights(!showAiInsights);
                      }}
                    >
                      <span className="ai-insights-icon">&#9679;</span>
                      {showAiInsights ? "Hide insights" : "Why this match"}
                      <span className={`ai-insights-chevron ${showAiInsights ? "open" : ""}`}>&#8250;</span>
                    </button>
                    {showAiInsights && (
                      <div className="ai-insights-content">
                        {aiHighlights && aiHighlights.length > 0 && (
                          <ul className="ai-insights-highlights">
                            {aiHighlights.map((h, i) => (
                              <li key={i}>{h}</li>
                            ))}
                          </ul>
                        )}
                        <p className="ai-insights-explanation">{aiExplanation}</p>
                      </div>
                    )}
                  </div>
                )}

                <div className="property-agent-info mx-0">
                  {/* Agent info - show all agents on demo feed */}
                  {(() => {
                    if (!Is_Agent_Created) {
                      return (
                        <span className="property-not-agent-name">
                          {AdType === 1 ? "Buyer" : "Renter"}
                        </span>
                      );
                    }

                    // Show full agent info
                    return (
                      <>
                        <div className="property-agent-profile-wrap">
                          <img
                            src={userAvatar || DefaultProfile}
                            alt="avatar"
                            className="property-agent-profile"
                            width={"35px"}
                            height={"35px"}
                          />
                        </div>
                        <div className="property-agent-created">
                          <div className="property-agent-created__head">
                            {userFirstName} {userLastName}
                            {flags.proBadge ? (
                              <span className="property-agent-created__badge">
                                PRO
                              </span>
                            ) : null}
                          </div>
                          <div className="property-agent-requested-infoo">{isDemoTenant ? `${tenant?.head?.title?.replace(" - Buyer Listing Service", "") || "MLS"} #BLS${blsId}` : `Agent @ ${userCompany}`}</div>
                        </div>
                      </>
                    );
                  })()}
                </div>
              </div>
              <div className="social-btns-wrap rmt-12"></div>
            </div>
          </div>
          <ViewAddClientsModal
            show={modalShow}
            showAddToClientWantAdModal={() => setModalShow(true)}
            onHide={() => setModalShow(false)}
            data={props.results}
            handleSkip={() =>
              handleFavoriteOrUnfavoriteWantAd(isFavourite, wantAdId)
            }
            handleConfirm={handleClientFavoriteWantAd}
            searchText={props.clientSearchText}
            onChangeText={(e) => onChangeText(e)}
            onAddClient={() => onAddClient()}
          />
        </div>
      </a>
    </>
  );
};

export default PropertyWantAdListingMob;

const HiddenAgentInfo = ({ Is_Agent_Created, AdType, userUserTypeId }) => {
  return (
    <>
      <div className="property-agent-profile-wrap">
        <img
          src={DefaultProfile}
          alt="avatar"
          className="property-agent-profile"
          width={"35px"}
          height={"35px"}
        />
      </div>
      {Is_Agent_Created && userUserTypeId !== 1 ? (
        <div className="property-not-agent-name">Agent</div>
      ) : (
        <span className="property-not-agent-name">
          {AdType === 1 ? "Buyer" : "Renter"}
        </span>
      )}
    </>
  );
};
